module.exports = __webpack_public_path__ + "img/welcome-logo-mark.00e278ce.png";